import React from 'react';
import { defineMessages } from 'react-intl';
import { mapValues, isBoolean, get, keyBy, isPlainObject } from 'lodash';

import pagesCollection from './pages';
import { EVENT_FAQ_CONST } from '../../shared-components/faq/data/constants';
import { TimeMap } from '../../elements-date-time/data/time-data';

const {
  PLACE_SETTINGS,
  CUPS_GLASSES,
  WINE_GLASSES,
  TABLES,
  CHAIRS,
  SOFT_SEATING,
  STANDARD_RESTROOMS,
} = EVENT_FAQ_CONST;


const pageInfo = (page) => {
  const pageKey = keyBy(pagesCollection, 'page');
  return {
    header: get(pageKey, [page, 'label'], ''),
    icon: get(pageKey, [page, 'icon'])
  };
};

const mapBoolToString = (obj) => mapValues(obj, (value) => isBoolean(value) ? String(value) : value);

const booleanSwitch = defineMessages({
  yes: {
    id: 'hosting.boolean_switch.yes',
    defaultMessage: 'Yes'
  },
  no: {
    id: 'hosting.boolean_switch.no',
    defaultMessage: 'No'
  }
});

const getFormattedTime = (index) => {
  return {
    time: {
      h: get(TimeMap, `[${index}].h`),
      m: get(TimeMap, `[${index}].m`)
    }
  };
};

const hasQuantityProperty = new Set([
  PLACE_SETTINGS,
  CUPS_GLASSES,
  WINE_GLASSES,
  TABLES,
  CHAIRS,
  SOFT_SEATING,
  STANDARD_RESTROOMS
]);

const hasQuantityAndDescription = (fields, selector, state) => {
  return fields.reduce((accumulator, key) => {
    const selectedState = selector(state, key);
    const baseObject = {};
    // Skip processing for boolean values
    if (isBoolean(selectedState)) return accumulator;
    if ('true' === selectedState || 'false' === selectedState) {
      const show = selectedState === 'true';
      baseObject[`${key}_description`] = show;
      baseObject[`${key}_quantity`] = show && hasQuantityProperty.has(key);
    }

    // Merge the current key's object with the accumulator
    return { ...accumulator, ...baseObject };
  }, {});
};

const seedValuesWithSelected = ((eventFaq) => {
  return Object.keys(eventFaq)
    .reduce((acc, key) => {
      if (isPlainObject(eventFaq[key])) {
        // set toggle to Yes / true
        acc[key] = true;
        // populate initial values with quantity and description fields
        if (eventFaq[key].hasOwnProperty('quantity')) {
          acc[`${key}_quantity`] = (eventFaq[key] || {}).quantity;
        }
        if (eventFaq[key].hasOwnProperty('description')) {
          acc[`${key}_description`] = (eventFaq[key] || {}).description;
        }
      } else {
        acc[key] = eventFaq[key];
      }

      return acc;
    }, {})
});

export {
  mapBoolToString,
  pageInfo,
  booleanSwitch,
  getFormattedTime,
  hasQuantityAndDescription,
  seedValuesWithSelected
};
